import api from 'api'
import { User } from 'api/typings'

export const getUserWorkExperience = async (id: User['id']) => {
  if (!id) {
    throw new Error('User id is required')
  }

  const workExperience = await api
    .get<Pick<User, 'workExperience'>>(`/admin/user/${id}/work_experience`)
    .then((result) => result.data)

  return workExperience
}
